"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var errorPageBaseTheme = function (breakpoints) {
    var _a, _b, _c, _d;
    var MAX_XS = breakpoints.MAX_XS, MAX_S = breakpoints.MAX_S, MIN_S = breakpoints.MIN_S, MAX_M = breakpoints.MAX_M, MAX_L = breakpoints.MAX_L;
    return ({
        errorPageSiteSectionLinks: (_a = {
                display: "grid",
                gridTemplateColumns: "repeat(5, 1fr)",
                gridAutoRows: "minmax(6rem, max-content)",
                gridGap: "1rem"
            },
            _a[MIN_S] = {
                margin: "2rem 0.5rem",
            },
            _a[MAX_L] = {
                gridTemplateColumns: "repeat(4, 1fr)",
            },
            _a[MAX_M] = {
                padding: "1rem",
                gridTemplateColumns: "repeat(3, 1fr)",
            },
            _a[MAX_XS] = {
                gridGap: "0.5rem",
                gridTemplateColumns: "repeat(2, 1fr)",
            },
            _a),
        errorPageSiteSectionIcon: (_b = {
                width: "30px",
                height: "30px",
                display: "flex",
                alignSelf: "center",
                justifySelf: "center",
                "&> img": {
                    height: "100%",
                }
            },
            _b[MAX_S] = {
                marginTop: "1rem",
            },
            _b[MAX_XS] = {
                marginTop: "0.5rem",
                width: "30px",
                height: "30px",
            },
            _b),
        errorPageSiteSectionHref: (_c = {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                alignContent: "start",
                textDecoration: "none",
                overflowWrap: "break-word"
            },
            _c[MAX_S] = {
                width: "100%"
            },
            _c[MAX_XS] = {
                width: "100%"
            },
            _c),
        errorPageSiteSectionTitle: {
            fontWeight: "normal",
            marginTop: "0.25rem",
            textAlign: "center",
        },
        errorPageKnownIssuesLink: {
            fontSize: "1.25rem",
            lineHeight: "1.5",
            display: "inline-block"
        },
        errorPageKnownIssuesText: {
            fontSize: "1.25rem",
            lineHeight: "1.5",
            display: "inline-block"
        },
        errorPage: {},
        errorPageContainer: {
            margin: "1.5rem",
        },
        errorPageMessage: (_d = {
                fontSize: "1.25rem"
            },
            _d[MAX_S] = {
                maxWidth: "90%",
                lineHeight: "2rem"
            },
            _d),
    });
};
exports.default = errorPageBaseTheme;
//# sourceMappingURL=errorPage.js.map